import { FC } from 'react';
import PropTypes from 'prop-types';
import { Item } from '../../types/item';
import { ETemplateType } from '../../templates/types';
import { ItemAssetsCard as ItemAssetsCardDefault } from '../../templates/default/components/item/item-card-assets';
import { ItemAssetsCard as ItemAssetsCardAuthentique } from '../../templates/authentique/components/item/item-card-assets';
import { ItemAssetsCard as ItemAssetsCardVera } from '../../templates/vera-admin/components/item/item-card-assets';

interface ItemAssetsCardProps {
  item: Item;
  location?: 'event' | 'other';
}

export const ItemAssetsCard: FC<ItemAssetsCardProps> = (props) => {
  switch (process.env.REACT_APP_TEMPLATE as ETemplateType) {
    default:
    case ETemplateType.DEFAULT:
      return <ItemAssetsCardDefault {...props} />;
    case ETemplateType.AUTHENTIQUE:
      return <ItemAssetsCardAuthentique {...props} />;
    case ETemplateType.EBAY:
    case ETemplateType.VERA_ADMIN:
      return <ItemAssetsCardVera {...props} />;
  }
};

ItemAssetsCard.propTypes = {
  // @ts-ignore
  item: PropTypes.object.isRequired,
  location: PropTypes.oneOf(['event', 'other']),
};
